import { request } from "../../../services/api"
import type { BaseApiResponse, BasePagination } from "../../../types/api.ts"
import type { ContactRef } from "../types/compose.types.ts"
import type {
  ConsentChange,
  ContactConsent,
  OptOutRow
} from "../types/consent.types.ts"

const BASE_URL = "/communication"

// GETs come back bare; writes are enveloped — read them with `unwrapEnvelope`.

export const getContactConsent = (contact: ContactRef) =>
  request.api.get<ContactConsent, BaseApiResponse<void>>(
    `${BASE_URL}/contacts/${contact.type}/${contact.id}/consent/`
  )

export const recordConsent = (contact: ContactRef, change: ConsentChange) =>
  request.api.patch<BaseApiResponse<ContactConsent>, BaseApiResponse<void>>(
    `${BASE_URL}/contacts/${contact.type}/${contact.id}/consent/`,
    change
  )

export const getOptOuts = (params: Record<string, string | number>) =>
  request.api.get<BasePagination<OptOutRow>, BaseApiResponse<void>>(
    `${BASE_URL}/opt-outs/`,
    params
  )

export const requestMarketingSms = (contact: ContactRef) =>
  request.api.post<
    BaseApiResponse<{ message_id: string; status: string; reason: string }>,
    BaseApiResponse<void>
  >(`${BASE_URL}/contacts/${contact.type}/${contact.id}/marketing-sms-request/`)

export const recordInPersonMarketingConsent = (contact: ContactRef) =>
  request.api.post<void, BaseApiResponse<void>>(
    `${BASE_URL}/contacts/${contact.type}/${contact.id}/marketing-sms-in-person/`,
    { customer_completing: true }
  )
